import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';

import { registerLocaleData } from '@angular/common';

import {
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';

import { provideRouter } from '@angular/router';

import en from '@angular/common/locales/en';

import {
  en_US,
  provideNzI18n,
} from 'ng-zorro-antd/i18n';

import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';

// NG-ZORRO Providers
import { NzModalModule } from 'ng-zorro-antd/modal';

// Application
import { routes } from './app.routes';

import { authInterceptor } from './core/interceptors/auth.interceptor';
import { rmsSpinnerInterceptor } from './service/rms-spinner.interceptor';

import { RmsMenuService } from './service/rms-menu-service';
import { errorInterceptor } from './core/interceptors/error-interceptor';

registerLocaleData(en);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),

    provideRouter(routes),

    provideHttpClient(
      withInterceptors([authInterceptor, rmsSpinnerInterceptor, errorInterceptor])
    ),

    provideNzI18n(en_US),

    provideNzDateFnsAdapter(),

    // Register NzModalService globally
    importProvidersFrom(NzModalModule),

    RmsMenuService,
  ],
};
